import React from "react";
import styles from "./style.module.css";

import "rc-slider/assets/index.css";

import Slider, { Range } from "rc-slider";

import { LineInput } from "components/Inputs/LineInput";

export default class InputSlider extends React.PureComponent {
  render() {
    const {
      min,
      max,
      label,
      onChange,
      onAfterChange,
      value,
      step,
      marks,
      isDollar,
      isLocked,
      isWideLabel,
      hideSlider,
      className,
      style,
      endLabel,
      inputWidth
    } = this.props;

    return (
      <div className={(className ? className : "") + " " + styles.sliderHolder} style={style ? { ...style } : {}}>
        <div
          className={styles.label}
          style={label === undefined ? { width: "0px" } : isWideLabel ? { width: "200px" } : {}}
        >
          {label}
        </div>
        {hideSlider !== true && (
          <div className={styles.inputSlider}>
            <Slider
              type="range"
              min={min}
              max={max}
              onChange={isLocked || onChange === undefined ? () => {} : (value) => onChange(Number(value))}
              onAfterChange={
                isLocked || onAfterChange === undefined ? () => {} : (value) => onAfterChange(Number(value))
              }
              value={Number(value)}
              step={step ? step : 1}
              marks={marks}
              trackStyle={{ backgroundColor: "var(--aible-color)" }}
              handleStyle={
                isLocked
                  ? {
                      backgroundColor: "rgba(0, 0, 0, 0)",
                      borderColor: "rgba(0, 0, 0, 0)"
                    }
                  : {
                      backgroundColor: "var(--aible-color)",
                      borderColor: "white",
                      boxShadow: "0px 0px 6px 1px rgba(81, 47, 119, 0.35)"
                    }
              }
            />
          </div>
        )}
        <div className={styles.inputLine} style={{ width: inputWidth }}>
          <LineInput
            min={min}
            max={max}
            onChange={(val) => {
              if (onChange !== undefined) {
                onChange(val);
              }

              if (onAfterChange !== undefined) {
                onAfterChange(val);
              }
            }}
            value={value}
            isDollar={isDollar}
            isMediumBox
            isLocked={isLocked}
          />
        </div>
        {endLabel && <div className={styles.endLabel}>{endLabel}</div>}
      </div>
    );
  }
}
